<template>
    <div class="part-panel">
        <div class="mt-2 mb-2">
            <router-link :to="backLink()"><i class="fa fa-arrow-left" aria-hidden="true"></i> Back to Search</router-link>
        </div>
        <div class="d-flex flex-wrap mb-2" v-show="partPanel != 'wait'">
            <div class="part-header-panel d-flex flex-grow-1 pr-2 ul-red-panel ul-wide-border-panel">
                <div class="d-flex flex-column align-items-center justify-content-center pl-2 pr-2">
                    <img class="part-image" v-bind:src="partImageSrc(partContent.partImageURL)">
                    <a class="part-image-credit" target="_blank" rel="nofollow" v-bind:href="partContent.partImageCreditURL">{{partContent.partImageCreditName}}</a>
                </div>
                <div class="d-flex flex-column justify-content-center flex-grow-1 pl-2 pr-2">
                    <div class="d-flex justify-content-between align-items-baseline">
                        <h1 class="d-flex flex-column part-detail-mfr-header">
                            <span>{{partContent.manufacturer}}</span>
                            <span class="font-weight-bold">{{partContent.partNumber}}</span>
                        </h1>
                    </div>
                    <div class="part-detail-description" v-bind:title="partContent.description">{{partContent.description}}</div>
                </div>
            </div>
            <CompetitivePanel v-bind:competitivePart="competitivePart" v-bind:partContent="partContent"></CompetitivePanel>
        </div>
        <div class="tab-content ul-red-panel ul-wide-border-panel ul-light-background mb-3" v-show="partPanel == 'preview'">
            <PreviewPanel v-bind:previewData="previewContent" :requestPrompt="true" @openRequest="requestPart"></PreviewPanel>
            <ExportPanel v-bind:exportData="exportContent" v-bind:currentPartUid="currentPuid" v-bind:initialExportOptionValues="initialExportOptions" v-bind:showExport="showExport"></ExportPanel>
        </div>
        <div class="tab-content ul-red-panel ul-wide-border-panel mb-3" v-show="partPanel == 'wait' || partPanel == 'download' || partPanel == 'export_error' || partPanel == 'part_error'">
            <div class="wait-panel hide-flex flex-column align-items-center justify-content-center mt-2" v-show="partPanel == 'wait'">
                <img class="export-image" src="../../assets/images/placeholders/UL-Loading-4B.gif" />
                <h2 class="mb-3">Starting Your Download</h2>
                <div>
                    Manufacturer:
                    {{partContent.manufacturer}}
                </div>
                <div class="mb-3">
                    Manufacturer PN:
                    {{partContent.partNumber}}
                </div>
            </div>
            <div class="download-panel hide-flex flex-column align-items-center justify-content-center mt-2" v-show="partPanel == 'download'">
                <img class="export-image" src="@/assets/images/placeholders/UL-Loading-Done.gif" />
                <h2 class="mb-3">Download Complete</h2>
                <div>
                    Manufacturer:
                    {{partContent.manufacturer}}
                </div>
                <div class="mb-3">
                    Manufacturer PN:
                    {{partContent.partNumber}}
                </div>
                <div class="d-flex flex-column align-items-center justify-content-center mt-2 mb-2">
                    <a class="small back-link" href="#" v-on:click.prevent="returnLink">Back to Preview</a>
                </div>
            </div>
            <div class="download-panel hide-flex flex-column align-items-center justify-content-center mt-2" v-show="partPanel == 'export_error'">
                <img class="export-image" src="@/assets/images/placeholders/UL-Loading-Done.gif" />
                <h2 class="mb-3">Download Has Failed</h2>
                <div>
                    Manufacturer:
                    {{partContent.manufacturer}}
                </div>
                <div class="mb-3">
                    Manufacturer PN:
                    {{partContent.partNumber}}
                </div>
                <div class="d-flex flex-column align-items-center justify-content-center mt-2 mb-2">
                    <a class="small back-link" href="#" v-on:click.prevent="returnLink">Back to Preview</a>
                </div>
            </div>
            <div class="download-panel hide-flex flex-column align-items-center justify-content-center mt-2" v-show="partPanel == 'part_error'">
                <img class="export-image" src="@/assets/images/placeholders/UL-Loading-Done.gif" />
                <h2 class="mb-3">Part has failed to load</h2>
            </div>
        </div>
        <div class="tab-content ul-red-panel ul-wide-border-panel mb-3" v-if="partPanel == 'request'">
            <RequestPanel :content="requestContent" />
            <div class="d-flex flex-column align-items-center justify-content-center mt-2 mb-2">
                <a class="small back-link" href="#" v-on:click.prevent="returnLink">Back to Preview</a>
            </div>
        </div>
    </div>
    <PartReferenceDesigns v-bind:referenceDesigns="referenceDesigns"></PartReferenceDesigns>
    <CompatiblePanel v-bind:compatibleParts="compatiblePartsViewModel" v-bind:partContent="partContent"></CompatiblePanel>
    <div class="d-flex flex-row-reverse pl-2 pr-0">
        <AdvertiserPanel v-bind:adContent="manufacturerPanel"></AdvertiserPanel>
        <template v-for="advertiserPanel of distributorPanels" :key="advertiserPanel.advertiserName">
            <AdvertiserPanel v-bind:adContent="advertiserPanel"></AdvertiserPanel>
        </template>
    </div>
</template>

<script>
    import $ from 'jquery'
    import { mapGetters, mapState } from 'vuex'
    import { PreviewPanel } from '@ema/vue-sfc-ul-previews'
    import partApiClient from '@/services/apiServices/partApiClient.js'
    import accountApiClient from '@/services/apiServices/accountApiClient.js'
    import ExportPanel from '@/components/export/export-panel.vue'
    import RequestPanel from '@/components/request/request-panel.vue'
    import CompetitivePanel from '@/components/ad/competitive-part-panel.vue'
    import CompatiblePanel from '@/components/ad/compatible-part-panel.vue'
    import PartReferenceDesigns from '@/components/ad/part-reference-designs.vue'
    import AdvertiserPanel from '@/components/ad/advertiser-panel.vue'

    function hasPreview(source) {
        if (source && source.previews && source.types && source.names ) {
            if ( source.previews !== null && source.previews.length > 0 && source.types.length > 0 && source.names.length > 0) {
                return true;
            }
        }
        return null;
    }

    export default {
        name: 'PartPanel',
        components: {
            PreviewPanel,
            ExportPanel,
            RequestPanel,
            CompetitivePanel,
            CompatiblePanel,
            PartReferenceDesigns,
            AdvertiserPanel
        },
        computed: {
            ...mapGetters('oidcStore', [
                'oidcIsAuthenticated'
            ]),
            ...mapState({
                selectedPuid: state => state.navigation.selectedPuid,
                selectedEuid: state => state.navigation.selectedEuid,
                partrequest: state => state.partrequest,
                searchBackLink: state => state.navigation.searchBackLink,
                instance: state => state.instance,
                initialExportOptions: state => state.user.exportOptions
            }),
            partContent: function () {
                if (this.currentPuid == null && this.currentEuid == null && this.partrequest && this.partContentValue == null) {
                    return this.partrequest;
                } else {
                    return this.partContentValue;
                }
            },
            requestContent: function () {
                return {
                    mfr: this.partContent.manufacturer,
                    pn: this.partContent.partNumber,
                    puid: this.selectedPuid,
                    euid: this.selectedEuid
                }
            },
            showExport: function () {
                return hasPreview(this.previewContent.symbolPreview) || hasPreview(this.previewContent.footprintPreview) || this.previewContent.threeDContent.has3D;
            }
        },
        data() {
            return {
                partPanel: "preview",
                currentPuid: this.selectedPuid,
                currentEuid: this.selectedEuid,
                partContentValue: {
                    manufacturer: "",
                    partNumber: ""
                },
                previewContent: {
                    threeDContent: {
                        has3D: false,
                        uuid: "",
                        url: ""
                    },
                    symbolPreview: {},
                    footprintPreview: {}
                },
                competitivePart: null,
                compatiblePartsViewModel: null,
                exportContent: null,
                referenceDesigns: [],
                manufacturerPanel: null,
                distributorPanels: null
            }
        },
        methods: {
            returnLink: function () {
                this.partPanel = 'preview';
            },
            requestPart: function () {
                this.partPanel = 'request';
            },
            backLink: function () {
                if (this.searchBackLink != "")
                    return this.searchBackLink;
                else
                    return "/" + this.instance + "/search/";
            },
            getPart: async function (puid, euid)
            {
                await this.$router.isReady();

                return partApiClient.GetPartDetail(puid, euid).then(response => {
                    if (response.data) {
                        this.$store.dispatch('gtmPartLoaded', { mfrName: response.data.partContent.manufacturer, mfrPN: response.data.partContent.partNumber})
                        this.partContentValue = response.data.partContent;
                        this.previewContent = response.data.previewData;

                        this.competitivePart = response.data.competitivePart;
                        this.compatiblePartsViewModel = response.data.compatiblePartsViewModel;

                        this.referenceDesigns = response.data.referenceDesigns;

                        if (this.$parent.currentPanel == 'part' || this.$parent.currentPanel == 'placeholder') {
                            for (var i = 0; i < this.referenceDesigns.length; i++) {
                                this.$store.dispatch('gtmReferenceInfluence', { mfrName: this.referenceDesigns[i].manufacturerName, mfrPN: this.referenceDesigns[i].partNumber });
                            }
                        }

                        this.distributorPanels = response.data.distributorPanels;
                        this.manufacturerPanel = response.data.manufacturerPanel;
        
                        if (response.data.exportRequest && this.oidcIsAuthenticated) {
                            this.exportContent = response.data.exportRequest;
                            this.$store.commit('LOAD_CONSENT', response.data.exportRequest.exportConsentViewModels);
                            this.$store.commit('LOAD_OPTIONS', response.data.exportRequest.exportOptionViewModels);
                            this.$store.commit('LOAD_EXPORTS', response.data.exportRequest.selectedExportTokens);
                        } else {
                            this.exportContent = null;
                        }
                        this.$nextTick(() => {
                            $('.ul-html-tooltip').each(function (index, element) {
                                if ($(element) && $(element).data('tip')) {
                                    $(element).tooltip({
                                        html: true,
                                        title: $('#' + $(element).data('tip')).html()
                                    });
                                }
                            });
                        });
                    }
                }).catch(() => {
                    this.$store.commit('SET_GLOBAL_ERROR', 'Part Retrieval Failed');
                });
            },
            partImageSrc(imgSrc) {
                if (imgSrc != undefined && imgSrc != null && imgSrc != '')
                    return imgSrc;
                return require('../../assets/images/placeholders/Image-Unavailable.png');
            }
        },
        beforeUnmount() {
            this.unsubmutpartpanel();
            this.unsubactpartpanel();
        },
        async mounted()  {
            //subscribes to search mutations
            this.unsubmutpartpanel = this.$store.subscribe(async (mutation, state) => {
                switch (mutation.type) {
                    case "SELECT_PART_NUMBER":

                        if (state.navigation.selectedPuid)
                            this.currentPuid = encodeURIComponent(state.navigation.selectedPuid);
                        if (state.navigation.selectedEuid)
                            this.currentEuid = encodeURIComponent(state.navigation.selectedEuid);
                        //then go get the part
                        this.getPart(this.currentPuid, this.currentEuid).then(() => {
                            this.partPanel = 'preview';
                            this.$store.commit('CHANGE_PANEL', 'part');
                        });
                        break;
                    case "LOAD_OPTIONS":
                        if (this.initialExportOptions == null || this.initialExportOptions.length == 0) {
                            accountApiClient.GetProfileSettings().then(response => {
                                if (response.data) {
                                    this.$store.commit('SET_USER_SETTINGS', response.data.exportOptionValues);
                                }
                            }).catch(() => {
                                this.$store.commit('SET_GLOBAL_ERROR', 'User Profile Unavailable');
                            });
                        }
                }
            })
            this.unsubactpartpanel = this.$store.subscribeAction(async (action) => {
                switch (action.type) {
                    case 'downloadStart':
                        this.partPanel = 'wait';
                        break;
                    case 'downloadComplete':
                        this.partPanel = 'download';
                        break;
                    case 'downloadFailure':
                        this.partPanel = 'export_error';
                        break;
                }
            });
        },
    };
    //pass content to tcl
</script>

<style>
    .part-detail-mfr-header {
        font-size: 16px;
    }

    .part-header-panel {
        max-width: 540px;
    }

    .part-detail-header {
        height: 90px;
    }

    .part-detail-description {
        max-width: 430px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        font-size: 80%;
    }

    .hide-flex {
        display: -ms-flexbox;
        display: -webkit-box;
        display: flex;
    }

    @media (min-width: 1300px ) {
        ul.nav {
            display: none !important;
        }

        .part-header-panel {
            margin-right: 1em;
        }
    }

    @media (max-width: 1299.99px ) {
        .preview-pane:not(.active), .preview-title {
            display: none;
        }

        .nav {
            display: -ms-flexbox !important;
            display: -webkit-box !important;
            display: flex !important;
        }

        .part-header-panel {
            max-width: 450px;
        }

        .part-detail-description {
            max-width: 330px;
        }
    }

    @media (max-width: 434.9px) {
        .part-header-panel {
            max-width: 400px;
        }

        .part-detail-description {
            max-width: 280px;
        }
    }
</style>